import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

export const Wrapper = styled.div<{ isIssueView: boolean }>`
    ${({ isIssueView }) =>
        isIssueView &&
        `
    margin-bottom: ${token('space.500')};
    

    #buttons {
        margin-top: ${token('space.200')};
        display: flex;
        justify-content: right;
    }
  `}
`;

export const WrapperRegex = styled.div`
    padding-block-start: ${token('space.100')};
    padding-inline-end: ${token('space.050')};
`;
